import { useEffect, useRef } from 'react'
import useDebounce from '../use-debounce'

/**
 * Debounces a value change and submits it to the callback once debounce is complete
 */
const useDebouncedCallback = ({
    value,
    callback,
    wait = 600
}) => {
    const lastValueRef = useRef(value)
    const debouncedValue = useDebounce(value, wait)
    useEffect(() => {
        if (lastValueRef.current !== debouncedValue) {
            lastValueRef.current = debouncedValue
            callback(debouncedValue)
        }
    }, [debouncedValue, callback])
    return debouncedValue
}

export default useDebouncedCallback